import React, {PropTypes} from 'react';
import TextInput from '../../common/TextInput';
import Button from '../../common/Button';
import {Link} from 'react-router';
import * as pathConstants from '../../../constants/pathConstants';
import * as googleCaptcha from '../../../constants/googleCaptcha';
const Recaptcha = require('react-gcaptcha');

const ForgotPasswordForm = ({
  onChange,
  onSubmit,
  onCancel,
  formErrors,
  reCaptchaCallback,
  sendingEmail,
  submitStatus
}) => {
  return (
    <div className="forgot-password-page">
      <div className="panel row">
        <div className="panel-body col-xs-6">
          <form className="">
            <TextInput
              type="text"
              name="email"
              placeholder="Place email here"
              label="Email Address"
              onChange={onChange}
              className="email-input"
              error={formErrors.email}/>
            <Recaptcha sitekey={googleCaptcha.key} verifyCallback={reCaptchaCallback}/>
            <div className="button-container">
              <Button
                disabled={!submitStatus || sendingEmail}
                value={sendingEmail ? 'Submitting...' : 'Submit'}
                className="submit-forgot-password col-sm-2 col-xs-12 pull-right"
                onClick={onSubmit}/>
              <a
                className="cancel-forgot-password col-sm-2 col-xs-12 pull-right"
                disabled={false}
                href="#"
                onClick={onCancel}>
                Cancel
              </a>
            </div>
          </form>
          <div id="create-account-link">
            If you don't have an account you can {} <Link to = {
            pathConstants.pathToCreateAccount}>create one here</Link>.
        </div>
      </div>
    </div>
  </div>
  );
};

ForgotPasswordForm.propTypes = {
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  formErrors: PropTypes.object,
  reCaptchaCallback: PropTypes.func.isRequired,
  sendingEmail: PropTypes.bool.isRequired,
  submitStatus: PropTypes.bool
};

export default ForgotPasswordForm;



/** WEBPACK FOOTER **
 ** ./src/components/authentication/ForgotPassword/ForgotPasswordForm.js
 **/